"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleBase = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var toggleTypeToInputType = function (type) {
    if (type === 'radio-button')
        return 'radio';
    return type;
};
var DEFAULT_ELEMENT = 'input';
exports.ToggleBase = react_1.default.forwardRef(function AOToggleBase(_a, ref) {
    var _b;
    var _c = _a.align, align = _c === void 0 ? 'left' : _c, _d = _a.as, ElementType = _d === void 0 ? DEFAULT_ELEMENT : _d, className = _a.className, children = _a.children, id = _a.id, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, _f = _a.labelProps, labelProps = _f === void 0 ? {} : _f, isPill = _a.pill, state = _a.state, type = _a.type, bodyClassName = _a.bodyClassName, props = __rest(_a, ["align", "as", "className", "children", "id", "fullWidth", "labelProps", "pill", "state", "type", "bodyClassName"]);
    return (
    // Input is nested, can't detect ElementType
    // eslint-disable-next-line jsx-a11y/label-has-for
    react_1.default.createElement("label", __assign({}, labelProps, { htmlFor: id, className: classnames_1.default(type, (_b = {
                flex: fullWidth
            },
            _b[type + "-pill"] = isPill,
            _b[type + "-reverse"] = align === 'right',
            _b), className) }),
        react_1.default.createElement(ElementType, __assign({ "data-aods": type }, props, { id: id, type: toggleTypeToInputType(type), ref: ref, className: type + "_input" })),
        react_1.default.createElement("span", { className: classnames_1.default(type + "_body", bodyClassName, {
                'text-error': state === 'error',
                'bg-error border-error': isPill && state === 'error',
            }) },
            react_1.default.createElement("span", { className: type + "_icon-container" },
                react_1.default.createElement("span", { className: type + "_icon" })),
            react_1.default.createElement("span", { className: type + "_label" }, children))));
});
exports.default = exports.ToggleBase;
//# sourceMappingURL=ToggleBase.js.map